import Vue from "vue";
import {
  getDatabase,
  ref,
  query,
  get,
  remove,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  orderByKey,
  endBefore,
  limitToLast,
} from "firebase/database";

import { createJLAI } from "@/common/functions";

import { ObjectToSortedArrayReverse } from "@/helpers/utils";

import { FETCH, REMOVE, LISTEN, RESPOND } from "../actions";
import { SET_KEY_NESTED, DEL_KEY_NESTED } from "../mutations";

const AVATAR_ID = "jlai";
const LIMIT_PAGE_MESSAGES = 10;

const database = getDatabase();

const getInitState = () => ({
  items: {},
  discussions: {},
});

const getters = {
  itemsSorted: (state) => () => {
    return ObjectToSortedArrayReverse(state.items, "createdAt");
  },

  discussionsSortedById: (state) => (discussionId) => {
    const result = ObjectToSortedArrayReverse(state.discussions, "createdAt");
    return result.filter((d) => d.discussionId === discussionId);
  },
};

const mutations = {
  [SET_KEY_NESTED](state, { key, id, ...payload }) {
    Vue.set(state[key], id, payload);
  },
  [DEL_KEY_NESTED](state, { key, id }) {
    Vue.delete(state[key], id);
  },
};

const actions = {
  async [FETCH]({ rootGetters, commit }, payload) {
    // const { uid } = rootGetters["auth/currentUser"];
    const { uid } = rootGetters["auth/currentUser"];
    const { lastKey, discussionId } = payload;

    const path = discussionId ? `discussionMessages/${discussionId}` : `messages`;

    const resultRef = lastKey
      ? query(
          ref(database, `avatars/${AVATAR_ID}/conversations/${uid}/${path}`),
          orderByKey(),
          endBefore(lastKey),
          limitToLast(LIMIT_PAGE_MESSAGES)
        )
      : query(ref(database, `avatars/${AVATAR_ID}/conversations/${uid}/${path}`), orderByKey(), limitToLast(LIMIT_PAGE_MESSAGES));
    console.log(`avatars/${AVATAR_ID}/conversations/${uid}/${path}`);
    const snapshot = await get(resultRef);

    const data = snapshot.val();

    if (data) {
      const key = discussionId ? "discussions" : "items";

      Object.entries(data).forEach(([id, data]) => {
        commit(SET_KEY_NESTED, { key, id, discussionId, ...data });
      });
    }

    return { isSuccess: true, data };
  },
  async [REMOVE]({ rootGetters, commit }, { id }) {
    const { uid } = rootGetters["auth/currentUser"];

    /* TODO: Handle Discussion */
    await remove(ref(database, `avatars/${AVATAR_ID}/conversations/${uid}/messages/${id}`));
    commit(DEL_KEY_NESTED, { key: "items", id });

    return { isSuccess: true, id };
  },

  async [LISTEN]({ rootGetters, commit }, payload) {
    const { uid } = rootGetters["auth/currentUser"];
    const { discussionId } = payload;

    const path = discussionId ? `discussionMessages/${discussionId}` : `messages`;

    const resultRef = query(
      ref(database, `avatars/${AVATAR_ID}/conversations/${uid}/${path}`),
      orderByKey(),
      limitToLast(LIMIT_PAGE_MESSAGES)
    );

    console.log("Listening to...", `avatars/${AVATAR_ID}/conversations/${uid}/${path}`);
    const key = discussionId ? "discussions" : "items";

    onChildAdded(resultRef, (snapshot) => {
      console.log("Child Added", snapshot.val());
      commit(SET_KEY_NESTED, { key, discussionId, id: snapshot.key, ...snapshot.val() });
    });

    onChildChanged(resultRef, (snapshot) => {
      commit(SET_KEY_NESTED, { key, discussionId, id: snapshot.key, ...snapshot.val() });
    });

    onChildRemoved(resultRef, (snapshot) => {
      commit(DEL_KEY_NESTED, { key, discussionId, id: snapshot.key });
    });
  },
  async [RESPOND]({ commit, rootState }, payload) {
    const { language = "en" } = rootState.auth.user;

    try {
      const { data } = await createJLAI({ avatarId: AVATAR_ID, language, ...payload });

      const { messageUser, messageAvatar } = data;

      commit(SET_KEY_NESTED, { key: "items", ...messageUser });
      commit(SET_KEY_NESTED, { key: "items", ...messageAvatar });

      // const { content } = messageUser;

      // const result = await textToSpeech({ text: content });
      // console.log("Audio", result);

      console.log("Payload2", { ...data });
      return { isSuccess: true, ...data };
    } catch (error) {
      console.log("ERR", error);
      return { isSuccess: false };
    }
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  mutations,
  actions,
};
